/** Deleting many items permanently asks for their number to be typed first. */
import { t } from "../../i18n/index.ts";

/** From how many items a selection deleted permanently asks for their number (a cleanup always does). */
const TYPE_FROM = 10;

/** "Type 214 to confirm": the number to type and how it's asked. */
export function typeCountLabel(count: number): string {
  return t("trash.typeCount", { text: String(count) });
}

/** Typing how many to delete permanently, for a selection of many (a few, or one, just confirm). */
export function typeCount(count: number): { typeToConfirm?: string; typeLabel?: string } {
  return count < TYPE_FROM ? {} : { typeToConfirm: String(count), typeLabel: typeCountLabel(count) };
}
